import { rouletteAudio } from './roulette.js';

/**
 * The app's two answers in sound, taken from the prize wheel so the whole app
 * speaks with one voice:
 *
 *  - **success** — the wheel's big prize, the sound of winning USDT: struck
 *    bars climbing an E major arpeggio, with its sparkle. It plays for a
 *    reward claimed from the miners or the tasks, a wallet linked, a
 *    withdrawal requested, and every success notice and toast.
 *  - **error** — the wheel's "nothing this time": two low wooden notes
 *    falling. It plays for every error notice.
 *
 * Toasts that only inform (grey gem) stay silent: they are notes, not
 * outcomes. Same engine as the wheel and the same volume (Profile →
 * Preferences; nought silences it). A burst of notices within a quarter of a
 * second is one sound, not a pile of them.
 *
 * A browser only lets sound start from a tap, and these answers arrive later,
 * when the server replies. So every tap anywhere in the app wakes the engine
 * (unlockSoundOnGesture), and by the time a claim comes back it can be heard.
 */

const GAP_MS = 250;
let lastAt = 0;

function play(weight: 'big' | 'none'): void {
  const now = Date.now();
  if (now - lastAt < GAP_MS) return;
  lastAt = now;
  rouletteAudio.prize(weight);
}

export const feedbackSound = {
  success: (): void => play('big'),
  error: (): void => play('none'),
};

/** Wakes the sound engine on the user's taps — the only moments a browser allows it. Returns the undo. */
export function unlockSoundOnGesture(): () => void {
  const wake = () => rouletteAudio.unlock();
  const events = ['pointerdown', 'touchend', 'click', 'keydown'] as const;
  for (const name of events) window.addEventListener(name, wake, { capture: true, passive: true });
  return () => {
    for (const name of events) window.removeEventListener(name, wake, { capture: true });
  };
}
